import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import styled from 'styled-components';
import Section from '../../section';
import Container from '../../container';
import ContentBlock from '../../content-block';
import ShareList from '../../share-list';
import RenderMd from '../../render-md';
import TextWave from '../../text-wave';
import UnstyledList from '../../../components/unstyled-list';
import InlineLink from '../../../components/inline-link';
import { SupportSection } from '../program-support';

const listStyles = `
  a {
    text-decoration: none;
  }
`;

const ProgramOverview = ({ content, router, programTitle, creator }) => {
  const url = `https://wavesforwater.org${router.asPath}`;

  return (
    <OverviewSection>
      <Container>
        <ContentBlock>
          <TextWave>
            <h2>Program Overview</h2>
          </TextWave>

          <UnstyledList styles={listStyles}>
            {creator && creator.id &&
              <li>
                Organizer: <InlineLink href={`/users/${creator.id}`}>{creator.firstName} {creator.lastName}</InlineLink>
              </li>
            }
          </UnstyledList>

          <RenderMd source={content} />

          <ShareList
            fbShareMessage={url}
            twitterShareMessage={`Support ${programTitle} - ${url}`}
            hasCircle
            styles="margin-bottom: 0;"
          />

        </ContentBlock>
      </Container>
    </OverviewSection>
  );
};

const OverviewSection = styled(Section)`
  :last-of-type { border-bottom: 1px solid ${props => props.theme.borderColor}; }

  + ${SupportSection} {
    padding-top: 0;
  }
`;

ProgramOverview.propTypes = {
  content: PropTypes.string,
  programTitle: PropTypes.string,
  creator: PropTypes.object,
};

export default withRouter(ProgramOverview);
